import { takeLatest, call, put } from 'redux-saga/effects';
import {
  loadPaymentMethods,
  loadPaymentMethodsSuccess,
  loadPaymentMethodsError,
  savePaymentMethodRequest,
  removePaymentMethodRequest,
} from './actions';
import {
  listPaymentMethods,
  createPaymentMethod,
  deletePaymentMethod,
} from '@/services/paymentMethods';
import { getActiveShopId } from '@/utils/shopSession';
import { hydratePaymentMethods } from '@/containers/posData/actions';
import type { PaymentMethod } from '@/lib/types';

function mapMethod(dto: any): PaymentMethod {
  return {
    id: String(dto.id),
    name: dto.name,
    isDefault: Boolean(dto.isDefault),
    type: dto.type ?? 'cash',
  };
}

export function* handleLoadPaymentMethods(): Generator<any, void, any> {
  try {
    const shopId = getActiveShopId();
    if (!shopId) {
      yield put(loadPaymentMethodsError('No active shop selected'));
      return;
    }
    const raw: any[] = yield call(listPaymentMethods, shopId);
    const methods = raw.map(mapMethod);
    yield put(hydratePaymentMethods(methods));
    yield put(loadPaymentMethodsSuccess(methods));
  } catch (e: any) {
    yield put(
      loadPaymentMethodsError(e?.message || 'Failed to load payment methods')
    );
  }
}

export function* handleSavePaymentMethod(
  action: ReturnType<typeof savePaymentMethodRequest>
): Generator<any, void, any> {
  try {
    const shopId = getActiveShopId();
    if (!shopId) return;
    yield call(createPaymentMethod, shopId, { name: action.payload.name, type: action.payload.type });
    yield put(loadPaymentMethods());
  } catch (e: any) {
    yield put(
      loadPaymentMethodsError(e?.message || 'Failed to save payment method')
    );
  }
}

export function* handleRemovePaymentMethod(
  action: ReturnType<typeof removePaymentMethodRequest>
): Generator<any, void, any> {
  try {
    const shopId = getActiveShopId();
    if (!shopId) return;
    yield call(deletePaymentMethod, shopId, Number(action.payload.id));
    yield put(loadPaymentMethods());
  } catch (e: any) {
    yield put(
      loadPaymentMethodsError(e?.message || 'Failed to remove payment method')
    );
  }
}

export default function* saga() {
  yield takeLatest(loadPaymentMethods.type, handleLoadPaymentMethods);
  yield takeLatest(savePaymentMethodRequest.type, handleSavePaymentMethod);
  yield takeLatest(removePaymentMethodRequest.type, handleRemovePaymentMethod);
}
